import { useDashboardSync, DIM_META, type Dimension } from "../../lib/dashboardSync";

type Props = { ywi: any };

// Per-dimension subtitle/recommendation copy (later: pulled from real recommendations)
const DESCRIPTIONS: Record<Dimension, string> = {
  physical:  "Active sessions + HRV trend",
  emotional: "Mood, stress, counseling cadence",
  mental:    "Meditation, focus, sleep quality",
  spiritual: "Coaching, purpose, journal depth",
  social:    "Group classes, community events",
};

export function WellnessLabsCard({ ywi }: Props) {
  const { active, setActive } = useDashboardSync();
  const dims = ywi ?? { physical: 0, emotional: 0, mental: 0, spiritual: 0, social: 0 };

  // Order: highest score first
  const sorted = (Object.keys(DIM_META) as Dimension[])
    .map((d) => ({ d, value: dims[d] ?? 0 }))
    .sort((a, b) => b.value - a.value);

  return (
    <div className="bg-d_card border border-d_border/20 rounded-[10px] p-3 transition-colors hover:border-d_celeste/10 h-full min-h-0 overflow-hidden flex flex-col">
      <div className="font-serif text-[17px] font-semibold mb-2.5 flex items-center justify-between tracking-[0.01em]">
        Wellness Labs
        <span className="text-[10px] tracking-[1.8px] uppercase text-d_text3 font-semibold">5 Dimensions</span>
      </div>

      <div className="space-y-2 overflow-y-auto flex-1 min-h-0 pr-1">
        {sorted.map(({ d, value }) => {
          const meta = DIM_META[d];
          const isActive = active === d;
          const pct = (value / 20) * 100;
          return (
            <button
              key={d}
              data-d={d}
              onMouseEnter={() => setActive(d)}
              onMouseLeave={() => setActive(null)}
              className={`w-full flex items-center gap-3 p-2.5 rounded-lg border text-left transition-all ${
                isActive ? "border-d_accent/50 bg-d_accent/[.05]" : "border-d_border/20 hover:border-d_accent/30 hover:bg-d_accent/[.03]"
              }`}
            >
              <div
                className="w-10 h-10 rounded-lg flex items-center justify-center text-xl flex-shrink-0"
                style={{ background: `${meta.color}1a` }}
              >
                {meta.icon}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-[14px] font-semibold leading-tight">{meta.label}</div>
                <div className="text-[10px] text-d_text3 leading-snug mt-0.5">{DESCRIPTIONS[d]}</div>
                <div className="w-full h-1.5 mt-2 bg-d_text/[.06] rounded-full overflow-hidden">
                  <div className="h-full rounded-full" style={{ width: `${pct}%`, background: meta.color }} />
                </div>
              </div>
              <div className="font-serif text-[24px] font-bold flex-shrink-0 tabular-nums" style={{ color: meta.color }}>
                {value.toFixed(1)}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
